// types
import { Account, Loan } from '../../../@types';

// i18n
import { useTranslation } from 'react-i18next';

// material
import { Alert, Grid, Typography, Paper, Box } from '@mui/material';

// ui
import { IconCircle } from '../IconCircle/IconCircle';

// props
export interface LoanAccountsProps {
	loan: Loan;
}

export const LoanAccounts = ({ loan }: LoanAccountsProps) => {
	const { t } = useTranslation();

	return (
		<Grid item xs={12}>
			<Paper
				elevation={0}
				sx={(theme) => {
					return {
						overflow: 'hidden',
					};
				}}
				variant="outlined">
				{loan.accounts?.length > 0 ? (
					<Box
						sx={(theme) => {
							return {
								padding: theme.spacing(2),
							};
						}}>
						<Grid container spacing={2}>
							{loan.accounts.map((account: Account, i) => {
								return (
									<Grid item key={`account-${i}`} xs={12}>
										<Grid alignItems={'center'} container key={`account-${i}`} spacing={2}>
											<Grid item xs={8}>
												<Grid alignItems="center" container spacing={1}>
													<Grid item>
														<IconCircle size="sm" type="account" />
													</Grid>
													<Grid flex={1} item>
														<Typography fontWeight={600}>{account.name}</Typography>
													</Grid>
												</Grid>
											</Grid>
											<Grid flex={1} item xs={4}>
												<Typography>{account.institution || t('na')}</Typography>
											</Grid>
										</Grid>
									</Grid>
								);
							})}
						</Grid>
					</Box>
				) : (
					<Alert severity="info">{t('alert.loanNoAccounts')}</Alert>
				)}
			</Paper>
		</Grid>
	);
};
